module.exports = __webpack_public_path__ + "img/funfacts3.6607b10c.png";